import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./Hazardperception.css";
import Sidebar from "../Components/Sidebar";

const HazardPerception = () => {
  const { id } = useParams();
  const videoRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timestamps, setTimestamps] = useState([]);
  const [result, setResult] = useState(null);
  const [clickCount, setClickCount] = useState(0);

  const lang = localStorage.getItem("lang") || "en";
  const getText = (en, bn) => (lang === "bn" ? bn : en);

  useEffect(() => {
    const fetchHazardVideo = async () => {
      try {
        const token = localStorage.getItem("jwtToken");
        if (!token)
          throw new Error(
            getText(
              "Unauthorized. Please log in.",
              "অননুমোদিত। অনুগ্রহ করে লগইন করুন।"
            )
          );

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/hazard`,
          { id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.error) {
          setError(response.data.msg);
        } else {
          setVideoUrl(response.data.data.video);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHazardVideo();
  }, [id]);

  const handleHitTime = () => {
    if (videoRef.current) {
      const currentTime = videoRef.current.currentTime.toFixed(2);
      const newClickCount = clickCount + 1;
      setClickCount(newClickCount);
      setTimestamps((prev) => [...prev, parseFloat(currentTime)]);

      if (newClickCount > 5) {
        /* videoRef.current.pause(); */
        setResult({
          error: true,
          msg: getText(
            "You are clicking in a pattern that is not acceptable",
            "আপনি একটি অগ্রহণযোগ্য প্যাটার্নে ক্লিক করছেন"
          ),
        });
      }
    }
  };

  const handleVideoEnd = async () => {
    if (clickCount > 5) return;

    try {
      const token = localStorage.getItem("jwtToken");
      if (!token)
        throw new Error(
          getText(
            "Unauthorized. Please log in.",
            "অননুমোদিত। অনুগ্রহ করে লগইন করুন।"
          )
        );

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/submit_hazard`,
        {
          id: id,
          timestamp: timestamps,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          validateStatus: () => true,
        }
      );

      if (response.status === 400 || response.data.error) {
        setResult({ error: true, msg: response.data.msg });
      } else {
        setResult({
          error: false,
          score: response.data.data.score,
          timestamps: response.data.data.timestamps,
        });
      }
    } catch (err) {
      setResult({ error: true, msg: err.message });
    }
  };

  if (loading)
    return (
      <div className="hazard-loading">
        {getText("Loading video...", "ভিডিও লোড হচ্ছে...")}
      </div>
    );
  if (error)
    return (
      <div className="hazard-error">
        {getText("Error:", "ত্রুটি:")} {error}
      </div>
    );

  return (
    <div className="overview">
      <Sidebar />
      <div className="hazard-video-container">
        <video
          ref={videoRef}
          className="hazard-video"
          disablePictureInPicture
          controlsList="nodownload nofullscreen noplaybackrate"
          onContextMenu={(e) => e.preventDefault()}
          autoPlay
          onEnded={handleVideoEnd}
          onClick={handleHitTime}
        >
          <source src={videoUrl} type="video/mp4" />
          {getText(
            "Your browser does not support the video tag.",
            "আপনার ব্রাউজার ভিডিও ট্যাগ সমর্থন করে না।"
          )}
        </video>

        {/* Flags Display */}
        <div className="flags-container">
          {timestamps.map((time, index) => (
            <div key={index} className="flag">
              🚩 {time}s
            </div>
          ))}
        </div>

        {/* Result Display */}
        {result && (
          <div className="hazard-result">
            {result.error ? (
              <p style={{ color: "red" }}>
                {getText("Error:", "ত্রুটি:")} {result.msg}
              </p>
            ) : (
              <div>
                <h3>{getText("Result", "ফলাফল")}</h3>
                <p>
                  {getText("Score", "স্কোর")}: <strong>{result.score}</strong>
                </p>
                <p>
                  {getText("Your Timestamps", "আপনার টাইমস্ট্যাম্পগুলি")}:{" "}
                  {result.timestamps.join(", ")}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default HazardPerception;
